import React, { useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { Paginator } from "primereact/paginator"; // Import Paginator
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Custom Styled Wrapper for the Carousel
const CarouselWrapper = styled.div`

 max-width: 100%;
  overflow: hidden;

  .slick-list {
    max-width: 100%;
    overflow: hidden;
  }

  .slick-prev,
  .slick-next {
    z-index: 1;
    font-size: 2rem;
  }

  .slick-prev:hover,
  .slick-next:hover {
    color: #000;
  }

  .slide-item {
    padding: 10px;
  }
`;

const CustPaginator = styled(Paginator)`
  .p-paginator-pages .p-paginator-page.p-highlight {
    background: #010101;
    color: #fff;
  }

  .p-paginator-pages .p-paginator-page {
    color: #010101;
    font-weight: bold;
    cursor: pointer;
  }

  .p-paginator-pages .p-paginator-page:hover {
    background: #010101;
    color: #fff;
  }
`;

// Carousel Component
const CommonCarousel = ({
  data,
  rows = 1,
  slidesToShow = 3,
  onSlideClick,
  renderSlideMedia,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: slidesToShow, // Navigate one page at a time
    rows, // Number of rows in the slider
    arrows: true, // Enable navigation arrows
    beforeChange: (_, next) => setCurrentPage(next / slidesToShow),
  };

  const onPageChange = (e) => {
    setCurrentPage(e.page);
    sliderRef.slickGoTo(e.page * slidesToShow);
  };

  let sliderRef;

  const renderSlide = (item, index) => (
    <div
      key={index}
      className="slide-item p-0 "
      onClick={() => onSlideClick && onSlideClick(index)}
    >
      {typeof renderSlideMedia === "function" ? (
        renderSlideMedia(item, index)
      ) : item.image ? (
        <img
          src={item.image}
          alt={item.title}
          style={{ width: "100%", height: "auto" }}
        />
      ) : (
        <video
          src={item.videoUrl}
          controls
          style={{ width: "100%", height: "auto" }}
        />
      )}
      <h2 style={{ fontSize: "1.5rem", textAlign: "left" }}>{item.title}</h2>
      <p style={{ textAlign: "left" }}>{item.description}</p>
    </div>
  );

  return (
    <div className="" style={{maxWidth:'100%'}}>
      <CarouselWrapper>
        <Slider className="m-0 p-0" ref={(slider) => (sliderRef = slider)} {...settings}>
          {data.map((item, index) => renderSlide(item, index))}
        </Slider>
      </CarouselWrapper>
      <div className="paginator-wrapper d-flex justify-content-end p-0 ">
        <CustPaginator
          first={currentPage * slidesToShow}
          rows={slidesToShow}
          totalRecords={data.length}
          onPageChange={onPageChange}
          prevPageLinkIcon={
            <i
              className="pi pi-arrow-circle-left p-0"
              style={{ fontSize: "2rem"  }}
            ></i>
          }
          nextPageLinkIcon={
            <i
              className="pi pi-arrow-circle-right"
              style={{ fontSize: "2rem" }}
            ></i>
          }
          currentPageReportTemplate="{currentPage} of {totalPages}"
          template="PrevPageLink CurrentPageReport NextPageLink"
        />
      </div>
    </div>
  );
};

export default CommonCarousel;
